import React from 'react';

const VoiceSelector = ({ selectedVoice, onVoiceChange, disabled = false }) => {
  return (
    <div className="flex items-center justify-center gap-0.5 mt-2">
      <button
        onClick={() => onVoiceChange('male')}
        disabled={disabled}
        className={`
          relative flex items-center justify-center px-3 py-1.5 rounded-l-full text-sm font-medium
          transition-all duration-200 border
          ${selectedVoice === 'male' 
            ? 'bg-primary text-white border-primary' 
            : 'bg-background-secondary text-content-secondary border-border hover:border-primary/50'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
        aria-label="Male voice"
      >
        <span lang="ja">男</span>
      </button>
      <button
        onClick={() => onVoiceChange('female')}
        disabled={disabled}
        className={`
          relative flex items-center justify-center px-3 py-1.5 rounded-r-full text-sm font-medium
          transition-all duration-200 border border-l-0
          ${selectedVoice === 'female' 
            ? 'bg-primary text-white border-primary' 
            : 'bg-background-secondary text-content-secondary border-border hover:border-primary/50'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
        aria-label="Female voice"
      >
        <span lang="ja">女</span>
      </button>
    </div>
  );
};

export default VoiceSelector;